const m = {
  mobile: {
    min: 375,
    max: 767
  },
  tablet: {
    min: 768,
    max: 1279
  },
  desktop: {
    min: 1280,
    max: 1440
  }
}, a = {
  mobile: {
    min: `@media (max-width: ${m.mobile.min}px)`,
    max: `@media (max-width: ${m.mobile.max}px)`
  },
  tablet: {
    min: `@media (max-width: ${m.tablet.min}px)`,
    max: `@media (max-width: ${m.tablet.max}px)`
  },
  desktop: {
    min: `@media (max-width: ${m.desktop.min}px)`,
    max: `@media (max-width: ${m.desktop.max}px)`
  }
};
export {
  m as BREAKPOINT,
  a as DEVICE
};
//# sourceMappingURL=breakpoint.es.js.map
